let THREE = require('three');

class ConvertAfebToMesh {



  parseASCII (data, thinning) {

    var length, normal, patternNormal, patternVertex, result, text;
    var faceInd = 0;
    var geometry = new THREE.Geometry();
    var patternFace = /facet([\s\S]*?)endfacet/g;
    var patternNode = /Node([\s\S]*?)endNode/g;
    var offset = 0;
    var r, g, b;
    var nFaces;
    var facesFound = false;

    var start = Date.now();

    var nodeT = new Float32Array(123000);
    var nodeF = new Float32Array(123000);

    // get Nodes
    while ( ( result = patternNode.exec( data ) ) !== null ) {

      facesFound = true;
      text = result[ 0 ];

      patternVertex = /vertex[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;

      while ( ( result = patternVertex.exec( text ) ) !== null ) {

        var v1 = parseFloat( result[ 1 ]);
        var v2 = parseFloat( result[ 3 ]);
        var v3 = parseFloat( result[ 5 ]);
        geometry.vertices.push( new THREE.Vector3( v1 , v2 , v3 ) );
      }

      patternNormal = /normal[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;

      while ( ( result = patternNormal.exec( text ) ) !== null ) {
        offset += 0;
      }

      patternValue = /values[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;

      while ( ( result = patternValue.exec( text ) ) !== null ) {
        nodeT[offset] = parseFloat( result[ 1 ]);
        nodeF[offset] = parseFloat( result[ 3 ]);
      }
      offset += 1;
    }

    var simResT = new Float32Array(123000);
    var simResF = new Float32Array(123000);
    var ind_1 = new Float32Array(123000);
    var ind_2 = new Float32Array(123000);
    var ind_3 = new Float32Array(123000);

    while ( ( result = patternFace.exec( data ) ) !== null ) {

      facesFound = true;
      text = result[ 0 ];
      patternNormal = /normal[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;

      while ( ( result = patternNormal.exec( text ) ) !== null ) {

        normal = new THREE.Vector3( parseFloat( result[ 1 ] ), parseFloat( result[ 3 ] ), parseFloat( result[ 5 ] ) );

      }
      var patternValue = /values[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;

      while ( ( result = patternValue.exec( text ) ) !== null ) {
        simResT[faceInd] = parseFloat( result[ 1 ]);
        simResF[faceInd] = parseFloat( result[ 3 ]);
      }

      var patternValue = /nodeIndices[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;

      while ( ( result = patternValue.exec( text ) ) !== null ) {

        ind_1[faceInd] = parseInt( result[ 1 ]);
        ind_2[faceInd] = parseInt( result[ 3 ]);
        ind_3[faceInd] = parseInt( result[ 5 ]);
      }


      patternVertex = /vertex[\s]+([\-+]?[0-9]+\.?[0-9]*([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+[\s]+([\-+]?[0-9]*\.?[0-9]+([eE][\-+]?[0-9]+)?)+/g;

      while ( ( result = patternVertex.exec( text ) ) !== null ) {

      }

      length = geometry.vertices.length;

      var i1 = ind_1[faceInd];
      var i2 = ind_2[faceInd];
      var i3 = ind_3[faceInd];
      geometry.faces.push( new THREE.Face3( i1, i2, i3, normal ) );
      faceInd += 1;

    }
    nFaces = geometry.faces.length;

    geometry.hasColors = false;
    geometry.alpha = 0.8;
    geometry.computeBoundingBox();
    geometry.computeBoundingSphere();

    var val;
    var resColor = new Float32Array(3);

    for ( var face = 0; face < nFaces; face ++ ) {

      var color1 = new THREE.Color( 0x00ff00 );
      var color2 = new THREE.Color( 0x0000ff );
      var color3 = new THREE.Color( 0x0000ff );

      var ind1 = ind_1[face];
      var ind2 = ind_2[face];
      var ind3 = ind_3[face];
      var val1, val2, val3;
      val1 = nodeT[ind1];
      val2 = nodeT[ind2];
      val3 = nodeT[ind3];

      if (thinning) { // thinning
        val = simResT[face];

        resColor = this.colorTable(val);
        r = resColor[0];
        g = resColor[1];
        b = resColor[2];

        var resColor1 = this.colorTable(val1);
        var resColor2 = this.colorTable(val2);
        var resColor3 = this.colorTable(val3);

        color1.setRGB(resColor1[0], resColor1[1], resColor1[2]);
        color2.setRGB(resColor2[0], resColor2[1], resColor2[2]);
        color3.setRGB(resColor3[0], resColor3[1], resColor3[2]);
      } else { // formability
        val = simResF[face];
        switch(val)
        {
          case 0:
            r = 1;//penColor = Color::Red;
            g = 0;
            b = 0;
            break;
          case 1:
            r = 1;//penColor =  Color::Orange;
            g = 0.75;
            b = 0;
            break;
          case 2:
            r = 1;//penColor =  Color::Yellow;
            g = 1;
            b = 0;
            break;
          case 3:
            r = 0.5;//penColor =  Color::Aquamarine;
            g = 1;
            b = 0.83;
            break;
          case 4:
            r = 0.5;//penColor =  Color::LightGray;
            g = 0.5;
            b = 0.5;
            break;
          case 5:
            r = 0;//penColor =  Color::Blue;
            g = 0;
            b = 1;
            break;
          case 6:
            r = 1;//penColor =  Color::Magenta;
            g = 0;
            b = 1;
            break;
        }
        color1.setRGB(r,g,b);
        color2.setRGB(r,g,b);
        color3.setRGB(r,g,b);

      }

      geometry.faces[ face ].vertexColors[0] = color1;
      geometry.faces[ face ].vertexColors[1] = color2;
      geometry.faces[ face ].vertexColors[2] = color3;

    }

    if(facesFound){
      return (geometry);
    }
  }

  colorTable (dv) {
    var resClr = new Float32Array(3);
    var r,g,b;
    // Percentage based ramp from blue to Red(-negative thinning)

    if (-0.3 > dv)//Pink
    {
      r = 1.0;
      g = 0.1;
      b = 1.0;
    }
    else if (-0.3 <= dv && dv < -0.25)  //Pink to Red
    {
      r = 0.9 + ((dv + 0.3) * (1 - 0.9)) / (-0.25 + 0.3);
      g = 0.2 + ((dv + 0.3) * (-0.2)) / (-0.25 + 0.3);
      b = 0.9 + ((dv + 0.3) * (-0.9)) / (-0.25 + 0.3);
    }
    else if (-0.25 <= dv && dv < -0.20)//Red to Orange
    {
      r = 1.0;
      g = ((dv + 0.25) * (0.5)) / (0.25 - 0.20);
      b = 0;
    }
    else if (-0.20 <= dv && dv < -0.15)// Orange to Yellow
    {
      r = 1.0;
      g = 0.5 + ((dv + 0.20) * (1.0 - 0.5)) / (-0.15 + 0.20);
      b = 0;
    }

    else if (-0.15 <= dv && dv < -0.10)//Yellow to Green
    {
      r = 1.0 + (((dv + 0.15) * (-1.0)) / (-0.10 + 0.15));
      g = 1.0;
      b = 0;
    }
    else if (-0.10 <= dv && dv < -0.05)//Green to cyan
    {
      r = 0;
      g = 1.0;
      b = (((dv + 0.10) * (1.0)) / (0.10 - 0.05));
    }

    else if (-0.05 <= dv && dv < 0.0)// Cyan to Light Blue
    {
      r = 0;
      g = 1.0 + (((dv + 0.05) * (0.6 - 1.0)) / 0.05);
      b = 1.0;
    }

    else if (0.0 <= dv && dv < 0.05)//Light Blue to Blue
    {
      r = 0;
      g = (((dv - 0.0) *(0.2-0.6)) / 0.05) + 0.6;
      b = 1;
    }
    else if (dv >= 0.05) //Blue
    {
      r = 0;
      g = 0.2;
      b = 1.0;
    }
    else
    {
      //Console.WriteLine(dv);
    }
    resClr[0] = r;
    resClr[1] = g;
    resClr[2] = b;

    return resClr;
  }

  ensureString ( buf ) {
    if ( typeof buf !== "string" ) {

      var array_buffer = new Uint8Array( buf );
      var str = '';
      for ( var i = 0; i < buf.byteLength; i ++ ) {

        str += String.fromCharCode( array_buffer[ i ] ); // implicitly assumes little-endian

      }
      return str;

    } else {
      return buf;

    }
  }

  convertThinning(data) {
    return this.parseASCII( this.ensureString( data ), true);
  }

  convertFormability(data) {
    return this.parseASCII( this.ensureString( data ));
  }
}

export default ConvertAfebToMesh;




// WEBPACK FOOTER //
// ./client/app/common/services/afeb-conventor.js